import { SCOPE } from '../constants';
 
/**
 * Small domain rules shared by the Emission Factor screen.
 *
 * `electricity_company_core` used to be derived here too; it is a server
 * concern now (rule L4 / UI3) — see `app/utils/company_name.py` — so the client
 * neither computes nor sends it.
 */
 
/** A factor is ACTIVE while nothing supersedes it — rule EF2 / EF3. */
export const isActiveFactor = (factor) => !factor.superseded_by;
 
/** Scope 2 rows are identified by supplier + menu, everything else by name. */
export const activityDisplayName = (factor) => (
  factor.scope === SCOPE.SCOPE_2 && factor.ef_company_core
    ? `${factor.ef_company_core}${factor.ef_menu ? ` − ${factor.ef_menu}` : ''}`
    : factor.ef_name
);